import type { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { Panel } from '../components/Panel';
import { EmptyState } from '../components/EmptyState';

/** A page with a big title, then its content */
export function SectionPage({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <Stack spacing={{ xs: 1.5, md: 2 }} sx={{ maxWidth: 1100 }}>
      <Typography variant="h4" component="h1">
        {title}
      </Typography>
      {children}
    </Stack>
  );
}

/** A menu page that is not built yet */
export function ComingSoonPage({ title }: { title: string }) {
  return (
    <SectionPage title={title}>
      <Panel title={title}>
        <EmptyState>This page is coming soon.</EmptyState>
      </Panel>
    </SectionPage>
  );
}
